import { useState } from "react";

const CategoryButton = ({category, categoryDistribution}) => {

    const {name, id, attributes} = category;
    const [checked, setChecked] = useState(false);

    function inputToggler() {
        setChecked(!checked);
        categoryDistribution(id);
    }

    return (
        <>
            <li className="tv-program__tags-item">
                <label className="tag" data-category={id}>
                    <input className="tag__checkbox visuallyhidden" type="checkbox" name="tv-program-channel-type" onChange={inputToggler}/>
                    <span className="tag__text" style={checked ? {backgroundColor: attributes['background-color'], borderColor: attributes['background-color']} : {}}>{name}</span>
                </label>
            </li>
        </>
    );
};

export default CategoryButton;